/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AtApplicationsModel } from '../../models/at-applications-model';

export interface GetAtApplicationsLink$Params {
}

export function getAtApplicationsLink(http: HttpClient, rootUrl: string, params?: GetAtApplicationsLink$Params, context?: HttpContext): Observable<StrictHttpResponse<AtApplicationsModel>> {
  const rb = new RequestBuilder(rootUrl, getAtApplicationsLink.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AtApplicationsModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getAtApplicationsLink.PATH = '/api/systemoverview/atapplicationslink';
getAtApplicationsLink.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getAtApplicationsLink.ROOTURL = '/portal';
